import styled from "styled-components";

export const Wrapper = styled.div`
    font-family: ${({ theme }) => theme.default.fontFamily.primaryFont};
    color: ${({ theme }) => theme.default.color.text.medium};
`;
